// extracted by mini-css-extract-plugin
module.exports = {"LoaderContainer":"Loader_LoaderContainer__3oa0s","Spinner":"Loader_Spinner__1eLAl","spin":"Loader_spin__VbDq_"};